import { useParams } from 'react-router-dom';
import { gql } from '@apollo/client';
import BreadcrumbLayout from './BreadcrumbLayout';
import { useQueryWithMsg } from '../utils/hooks';

const TeamNameQuery = gql`
  query TeamNameQuery($id: ID!) {
    team(id: $id) {
      id
      name
    }
  }
`;

const TeamBreadcrumbLayout = () => {
  const { teamId } = useParams();
  const { msg, data } = useQueryWithMsg(TeamNameQuery, {
    variables: { id: teamId },
  });

  return (
    <BreadcrumbLayout
      rootUrl={`/app/team/${teamId}`}
      rootText={msg || data?.team?.name}
    />
  );
};

export default TeamBreadcrumbLayout;
